<div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">

        <div class="row" *ngIf="userObject">
            <div class="col-12">
                <h2>{{ 'pages.dashboard.welcome' | translate }} {{userObject.given_name}}</h2>
            </div>
            <div class="col-12" *ngIf="sinceLastLogin">
                <div class="alert lastLogin" role="alert">        
                    <div style="width:100%">
                        <h4>{{ 'pages.dashboard.sinceLogin' | translate }}</h4>
                        <div class="p-0" *ngFor="let act of sinceLastLogin" style="width:100%">
                            <a class="click" [routerLink]="[act.url]" routerLinkActive="router-link-active">
                                <li>
                                    {{act.count}} {{act.description}}
                                </li>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>


<div class="row rowfiller">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-3">
            <div class="col-lg-12">
                <h3>{{ 'pages.dashboard.worldwatch' | translate }}</h3>

                <ngb-carousel #carousel [interval]="5000" *ngIf="loadedSignals">
                    <ng-template ngbSlide *ngFor="let sig of latestSignals; index as i" >

                        <div class="row pb-5 click carouselHeight" [routerLink]="['/updates/worldwatch/viewSignal/' + sig.jiraRef]" routerLinkActive="router-link-active">
                            <div class="col-xl-2 col-lg-2 col-md-2 hidden-sm" style="background-size: 150px!important;" [ngClass]="sig.signalUrgency + sig.mainCategory | lowercase | removeWhiteSpace"></div>
                            <div class="col-xl-9 col-lg-9 col-md-9 col-sm-12">
                                <h3>{{sig.summary}}</h3>
                                <p>{{sig.whatYouWillHear}}</p>
                            </div>
                            <div class="col-xl-1 col-lg-1 col-md-1 hidden-sm"></div>
                        </div>

                    </ng-template>
                </ngb-carousel>

                <div class="row justify-content-center orangeText" *ngIf="loadedSignals && !latestSignals">
                    <fa-icon [icon]="['fas', 'exclamation-circle']" size="2x"></fa-icon>
                </div>

                <div class="row justify-content-center p-5" *ngIf="!loadedSignals">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>


<div class="row">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-3">
            <div class="col-lg-12">
                <h3>{{ 'pages.dashboard.supportActivity' | translate }} <app-help message=""></app-help></h3>

                <div class="row" *ngIf="loadedCaseStats && loadedOpenCases">
                    <div class="col-12">

                        <div class="row">
                            <div class="col-xl-6 col-lg-12 col-md-12 my-auto" >

                                <div class="row p-0">
                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="last30dayCreated || last30dayCreated === 0">{{last30dayCreated}}</h1>
                                                <h1 class="orangeText" *ngIf="!last30dayCreated && last30dayCreated != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700;  height: 75px">{{ 'pages.dashboard.created30days' | translate }}<br/><small> {{ 'pages.generic.previous' | translate }} 30 {{ 'pages.generic.days' | translate }}</small></h4>
                                                <a routerLink="/support/dashboard/created30days" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="last30dayClosed || last30dayClosed === 0">{{last30dayClosed}}</h1>
                                                <h1 class="orangeText" *ngIf="!last30dayClosed && last30dayClosed != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700;  height: 75px">{{ 'pages.dashboard.closed30days' | translate }}<br/><small> {{ 'pages.generic.previous' | translate }} 30 {{ 'pages.generic.days' | translate }}</small></h4>
                                                <a routerLink="/support/dashboard/closed30days" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div> -->
                                    <div class="col-xl-1 col-lg-1 col-md-1 d-md-block d-none p-0"></div>
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="openCases || openCases === 0">{{openCases}}</h1>
                                                <h1 class="orangeText" *ngIf="!openCases && openCases != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700; height: 50px">{{ 'pages.dashboard.openCases' | translate }}<br/><br/></h4>
                                                <a routerLink="/support/dashboard/opencases" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-2 col-lg-2 col-md-2 d-md-block d-none p-0"></div>
                                    <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="customerPending || customerPending === 0">{{customerPending}}</h1>
                                                <h1 class="orangeText" *ngIf="!customerPending && customerPending != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700;  height: 50px">{{ 'pages.dashboard.customerPending' | translate }}<br/><br/></h4>
                                                <a routerLink="/support/dashboard/customerpending" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-1 col-lg-1 col-md-1 d-md-block d-none p-0"></div>

                                    <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="newCriticalPriority || newCriticalPriority === 0">{{newCriticalPriority}}</h1>
                                                <h1 class="orangeText" *ngIf="!newCriticalPriority && newCriticalPriority != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700;  height: 75px">{{ 'pages.dashboard.newCritical' | translate }}<br/><small>{{ 'pages.generic.previous' | translate }} 30 {{ 'pages.generic.days' | translate }}</small></h4>
                                                <a routerLink="/support/dashboard/newcritical30days" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 p-0">
                                        <div class="card">
                                            <div class="card-body boxfiller text-center">
                                                <h1 class="orangeText" style="font-weight: 700;" *ngIf="newHighPriority || newHighPriority === 0">{{newHighPriority}}</h1>
                                                <h1 class="orangeText" *ngIf="!newHighPriority && newHighPriority != 0"><fa-icon [icon]="['fas', 'exclamation-circle']"></fa-icon></h1>
                                                <h4 class="mr-40 mt-20 description whiteText" style="font-weight: 700;  height: 75px">{{ 'pages.dashboard.newHigh' | translate }}<br/><small>{{ 'pages.generic.previous' | translate }} 30 {{ 'pages.generic.days' | translate }}</small></h4>
                                                <a routerLink="/support/dashboard/newhigh30days" class="btn btn-sm btn-primary">{{ 'pages.generic.view' | translate }}</a>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>

                            </div>
                            <div class="col-xl-6 col-lg-12 col-md-12 p-2">
                                <highcharts-chart
                                    [Highcharts]="Highcharts"
                                    [options]="catPieChartOptions"
                                    style="width: 100%; height: 300px; display: block;"
                                ></highcharts-chart>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center  p-5" *ngIf="!loadedCaseStats || !loadedOpenCases">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>


<div class="row rowfiller">
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
    <div class="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-xs-12">

        <div class="row pt-3">
            <div class="col-lg-12">
                <h3>{{ 'pages.dashboard.latestActivity' | translate }}</h3>

                <div *ngIf="subsetActivities && loadedActivities">
                    <div class="row faketablerow" *ngFor="let act of subsetActivities" [routerLink]="act.url" routerLinkActive="router-link-active" >

                        <ng-template #list>
                            <div [innerHTML]="act.iconAlt"></div>
                        </ng-template>

                        <div class="col-xl-1 col-lg-1 col-sm-2 col-2 faketablecell">
                            <fa-icon [icon]="['fas', 'briefcase']" size="lg" *ngIf="act.type === 'Case'"></fa-icon>
                            <fa-icon [icon]="['fas', 'radiation']" size="lg" *ngIf="act.type === 'Vulnerabilities'"></fa-icon>
                            <fa-icon [icon]="['fas', 'broadcast-tower']" size="lg" *ngIf="act.type === 'Signals'"></fa-icon>
                        </div>
                        <div class="col-xl-7 col-lg-7 col-md-9 col-sm-10 col-10 faketablecell" style="text-align: left;">{{act.count}} {{act.description}}</div>
                        <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketablecell" [ngClass]="act.iconStyle | lowercase | removeWhiteSpace" *ngIf="!act.iconAlt"> <span class="badge p-1 w-100" [ngClass]="'P' + act.priority | lowercase | removeWhiteSpace">{{act.priority}}</span></div>
                        <div class="col-xl-2 col-lg-2 col-md-2 d-none d-md-block faketablecell" [ngClass]="act.iconStyle | lowercase | removeWhiteSpace" placement="top" [ngbTooltip]="list" *ngIf="act.iconAlt"></div>

                        <div class="col-xl-2 col-lg-2 d-none d-lg-block faketablecell">{{act.date | date: 'dd/MM/yyyy HH:mm'}}</div>


                    </div>
                </div>

                <div class="card-body justify-content-center p-t-1 p-3" *ngIf="subsetActivities && loadedActivities">
                    <ngb-pagination [collectionSize]="activities.length" pageSize="12" page="currentPage" [(page)]="currentPage" [maxSize]="10" aria-label="Pagination" (pageChange)="pageActivity($event)">
                        <ng-template ngbPaginationPrevious></ng-template>
                        <ng-template ngbPaginationNext></ng-template>
                    </ngb-pagination>
                </div>

                <div class="row justify-content-center orangeText" *ngIf="loadedActivities && !subsetActivities">
                    <fa-icon [icon]="['fas', 'exclamation-circle']" size="2x"></fa-icon>
                </div>

                <div class="row justify-content-center  p-5" *ngIf="!loadedActivities">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">{{ 'pages.generic.loading' | translate }}</span>
                    </div>
                </div>

                <div class="row p-3 justify-content-center redborder-sides" *ngIf="subsetActivities && subsetActivities.length === 0">
                    <div class="col-md-12 table-border justify-content-center">
                        {{ 'pages.generic.noResults' | translate }}
                    </div>
                </div>

            </div>
        </div>

    </div>
    <div class="col-xl-1 col-lg-1 hidden-md"></div>
</div>